export default function fetchRelatedStories(storyId, sectionId) {
  return global
    .wretch(`/api/v1/stories/${storyId}/related-stories?section-id=${sectionId}`)
    .query({
      sectionId
    })
    .get()
    .json(response => response["related-stories"]);
}
